// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_97-4";
export var collapsed = "_97-1";
export var headerBar = "_97-0";
export var leftHeaderContent = "_97-3";
export var subjectContainer = "_97-2";